'use strict';

// TODO: remove, semver-major

module.exports = require('get-intrinsic');



//////////////////
// WEBPACK FOOTER
// ./node_modules/array.prototype.map/node_modules/es-abstract/GetIntrinsic.js
// module id = 851
// module chunks = 0